import * as React from 'react'

/**
 * Hook that alerts clicks outside of the passed ref
 */
export const useOnClickOutside = <E extends HTMLElement>(ref: React.RefObject<E>, callback: () => void) => {
  /**
   * Alert if clicked on outside of element
   */
  const handleClickOutside = (event: { target: HTMLElement }) => {
    if (ref.current && !ref.current.contains(event.target)) {
      callback()
    }
  }

  React.useEffect(() => {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      document.removeEventListener('mousedown', handleClickOutside)
    }
  })
}
